import '@hotmart/cosmos/dist/tooltip'
import {
  useTrackDatahubEvents,
  SendSuggestedCommentEventParams
} from 'src/hook/useTrackDatahubEvents'
import { Action } from 'src/utils/datahubDefaultEvent'
import { Entity } from 'src/utils/datahubDefaultEvent'
import { useCommentSuggestions, useMentionUtils } from '../../hooks'
import { CommentSuggestionSkeleton } from '../commentSuggestionSkeleton'
import { CommentSuggestionProps, HandleClickParams } from './commentSuggestion.types'
import {
  CommentSuggestionOption,
  CommentSuggestionOptions,
  Wrapper
} from './commentSuggestion.styles'

const CommentSuggestion = ({
  authorName,
  authorUcode,
  disabled,
  enableAI,
  postId,
  arrivedFrom,
  onClick
}: CommentSuggestionProps) => {
  const { renderMentionHTMLTag } = useMentionUtils()
  const { trackClickEvent } = useTrackDatahubEvents()

  const authorMention = renderMentionHTMLTag({
    name: authorName,
    ucode: authorUcode
  })?.trim()

  const { loading, suggestions } = useCommentSuggestions({
    enabledIA: enableAI,
    authorMention
  })

  const handleClick = ({ comment, option, position }: HandleClickParams) => {
    onClick(comment)
    trackClickEvent<SendSuggestedCommentEventParams>({
      action: Action.CLICK_SUGGESTED_COMMENT_CHIP,
      payload: {
        entity: Entity.COMMUNITY,
        componentName: arrivedFrom,
        hasAccessToTheCommunity: true,
        postId,
        commentPosition: position,
        suggestedComment: option
      }
    })
  }

  return (
    <Wrapper
      className="_d-flex _justify-content-center _flex-column _text-2 _pt-3 _justify-content-md-start _flex-md-row"
      data-test="comment-suggestion"
    >
      {loading && <CommentSuggestionSkeleton length={3} />}

      {!loading && (
        <CommentSuggestionOptions className="_d-flex">
          {suggestions.map(({ comment, commentWithMention, option }, index) => (
            <CommentSuggestionOption
              key={comment}
              className="_text-1 _text-gray-900 _d-flex _justify-content-center _align-items-center _px-3 _py-1 _border _border-gray-200 _rounded-pill _cursor-pointer"
              disabled={disabled}
              onClick={() =>
                handleClick({
                  comment: commentWithMention || comment,
                  option,
                  position: index + 1
                })
              }
            >
              {comment}
            </CommentSuggestionOption>
          ))}
        </CommentSuggestionOptions>
      )}
    </Wrapper>
  )
}

export default CommentSuggestion
